import gql from 'graphql-tag';

export default gql`
  query referralContactRequestHistory {
    referralContactRequestHistory {
      data {
        name
        registeredAt
        totalVoucherAmount
        status
      }
    }
  }
`;

